const SiteAPI = {
   
    list(query) {
        return Request.post('/admin/site/search', query);
    },
    save(data) {
        return Request.post('/admin/site/save', data);
    },
    remove(id) {
        return Request.delete(`/admin/site/delete/${id}`);
    },
    batchRemove(idArray) {
        return Request.post(`/admin/site/batchDelete`, idArray);
    },
    getSiteAdmin(siteId) {
        return Request.get(`/admin/site/${siteId}/getAdmin`);
    },
    open(siteId) {
        return Request.get(`/admin/site/${siteId}/openSite`);
    },
    close(siteId) {
        return Request.get(`/admin/site/${siteId}/closeSite`);
    },
    /**
     * 获取当前站点信息
     */
    currentSiteInfo() {
        return Request.get('/admin/settings/site');
    },

    /**
     * 更新当前站点信息
     */
    updateCurrentSiteInfo(data) {
        return Request.post('/admin/site/update', data);
    },

    /**
     * 获取站点信息
     * @param {} siteId
     */
    getSiteInfo(siteId) {
        if (siteId) {
            return Request.get(`/admin/site/${siteId}`);
        } else {
            return this.currentSiteInfo();
        }
    },
    /**
     * 根据域名获取站点信息
     * @param {} domain
     */
    getSiteInfoByDomainName(domain) {
        return Request.get(`/admin/site/getByDomainName/${domain}`);
    },
    /**
     * 获取菜单列表
     * @param data
     * @returns {*}
     */
    loadSiteNavMenus(position, query) {
        return Request.post(`/admin/site/navmenu/${position}`, query);
    },

    /**
     * 获取站点顶部导航菜单
     * @param {} query
     * @returns
     */
    loadTopMenus(query) {
        return this.loadSiteNavMenus('Top', query);
    },

    /**
     * 获取菜单列表
     * @param data
     * @returns {*}
     */
    loadBottomMenus(query) {
        return this.loadSiteNavMenus('Bottom', query);
    },

    /**
     * 获取菜单列表
     * @param data
     * @returns {*}
     */
    deleteNavMenu(menuId) {
        return Request.delete(`/admin/site/navmenu/delete/${menuId}`);
    },

    /**
     * 更新菜单
     * @param data
     * @returns {*}
     */
    saveNavMenu(menu) {
        return Request.post('/admin/site/navmenu/save', menu);
    },

    /**
     * 获取站点的客服信息
     * @returns
     */
    editCustomService() {
        return Request.get('/admin/siteCustomService/edit');
    },

    /**
     * 更新客服信息
     * @param data
     * @returns {*}
     */
    updateCustomService(customservice) {
        return Request.post('/admin/siteCustomService/save', customservice);
    },
    /**
     * 根据域名获取站点客服信息数据
     * @param {*} domainName
     * @returns
     */
    getSiteCustomServiceByDomain(domainName) {
        return Request.get(`/admin/siteCustomService/getSiteCustomServiceByDomain/${domainName}`);
    },
    /**
     * 获取当前站点的客服信息数据
     */
    getCurrentSiteCustomService() {
        return Request.get(`/admin/siteCustomService/getCurrentSiteCustomService`);
    },
    /**
     * 获取当前主题的组件
     * @returns
     */
    currentTheme(themeType) {
        return Request.get(`/admin/siteTheme/currentTheme/${Constants.Code.THEME_TERMINAL_PC}/${themeType}`);
    }
};

export default SiteAPI;
